import { FC } from "react";
import { Navigate } from "react-router-dom";
import { MARKETING_PAGE_PATH, PREMIUM_TRANSLATION_FULL_PATH } from "../utils/menuPathNormalize";
import { globalStore } from "../utils/globalStore";
import { getFirstHomeShellNavigationPath } from "../utils/homeShellSidebar";

/** 根路径：已登录进工作台，未登录进营销落地页 */
export const RootRedirect: FC = () => {
  const token = localStorage.getItem("token");
  if (token) {
    const firstPath = getFirstHomeShellNavigationPath(globalStore.getMenuList());
    return <Navigate to={firstPath || PREMIUM_TRANSLATION_FULL_PATH} replace />;
  }
  return <Navigate to={MARKETING_PAGE_PATH} replace />;
};
